<template>
    <div class="col-12 col-sm-12 col-md-12 col-lg-10">
        <div class="right-side-bar-main-sec deposit_section">
            <div class="deposit-withdraw-sec">
                <div class="go-to-back-sec">
                    <a @click="$router.go(-1)">
                        {{ $t('back', 'Back') }}
                    </a>
                </div>
                <div class="dw_bg_cl">
                    <div class="type_of_deposit_parent" v-if="Object.keys(parentPaymentsList || {}).length">
                        <div class="description-card-body payment_type_tabs_cl">
                            <div class="row">
                                <div class="col-12">
                                    <div class="deposit_tabs_cl">
                                        <div class="wallet_thm_title">
                                            <h2>Choose a payment method</h2>
                                        </div>
                                        <ul class="nav nav-tabs" id="myTab" role="tablist">
                                            <li v-for="(paymentData, payment) in parentPaymentsList" :key="payment" class="nav-item" role="presentation">
                                                <button class="nav-link" :class="{ active: activeTab === payment }, paymentBonusRef?.[paymentData?.[0]?.method_id] ? 'paymentBonus' : ''" @click="choosePaymentMethod(paymentData, payment)"
                                                data-bs-toggle="tab" :data-bs-target="'#tab-' + index" :id="'tabId' + index" role="tab" 
                                                type="button" :aria-controls="'tab-' + index" :aria-selected="index === 0">
                                                <div class="get-bonus-sec" v-if="paymentBonusRef?.[paymentData?.[0]?.method_id]">Get {{ paymentBonusRef?.[paymentData?.[0]?.method_id] }}% Bonus</div>
                                                    <figure class="deposit_fgr">
                                                        <figcaption>{{ payment }}</figcaption>
                                                        <img loading="lazy" :src="methodIcons[payment]" :alt="payment" />
                                                    </figure>
                                                </button>
                                            </li>
                                        </ul>
                                        <span v-if="accountDetails?.method == 'bank' && !isPaymentGateway && paymentDetailsList?.[0]?.method != 'social'">You can add through a bank transfer</span>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="description-card-body payment_type_tabs_content_cl" v-if="paymentDetailsList?.[0]?.method != 'social'">
                            <div class="payment-gateway-sec" v-if="isPaymentGateway">
                                <span>Pay using our payemnt gateway</span>
                                <a href="Javascript:void(0);" @click="goToPaymentGateway()" class="thm-but">{{ $t('pay-now', 'Pay Now') }}</a>
                            </div>
                            <div class="tab-content" id="myTabContent" v-if="!isPaymentGateway" >
                                <div class="tab-pane active" :id="'tab-' + index"
                                    role="tabpanel" :class="{ 'show active': index === 0 }" :aria-labelledby="'tabId' + index">
                                    <div class="depo-lft-container imps_deposit_sec imps_tabs_content">
                                        <div class="description-card-body account_data_parent_cl m-0">
                                            
                                            <div class="account-data"  v-for="(account, index) in paymentDetailsList" @click="changeAccount(account,index)" :key="index" :class="{ 'selected-card' : currentAccount === index }">
                                                <p class="card-text" v-if="account?.account_number || account?.phone_number">
                                                    {{ account?.account_number ? $t('account-number', 'Account Number') : $t('phone-number', 'Phone Number') }}
                                                        : <span>{{ account?.account_number ? account?.account_number : account?.phone_number }}</span>
                                                    <button class="btn txt_copy_cl" @click="copyPaymentData(account?.account_number ? $t('account-number', 'Account Number') : $t('phone-number', 'Phone Number'), account.account_number ? account.account_number : account.phone_number,index)">
                                                        <i class="fa-solid fa-copy"></i>
                                                    </button>
                                                    <div class="copt_text_hover" v-if="copiedText">
                                                        {{ $t('copied', ' Copied') }}!
                                                    </div>
                                                </p>
                                                <p class="card-text">
                                                    {{ account?.account_number ? $t('ifsc-code', 'IFSC Code') : account?.upi_id ? $t('upi-id', 'UPI ID') : $t('wallet-id', 'Wallet ID') }}
                                                        : <span>{{ account?.account_number ? account?.ifsc_code : (account?.upi_id || account?.crypto_wallet_id) }}</span>
                                                    <button class="btn txt_copy_cl" @click="copyPaymentData(account.account_number ? $t('ifsc-code', 'IFSC Code') : account?.upi_id ? $t('upi-id', 'UPI ID') : $t('wallet-id', 'Wallet ID'), account.account_number ? account.ifsc_code : (account?.upi_id || account?.crypto_wallet_id),index)">
                                                        <i class="fa-solid fa-copy"></i>
                                                    </button>
                                                    <div class="copt_text_hover" v-if="copiedText">
                                                        {{ $t('copied', ' Copied') }}!
                                                    </div>
                                                </p>
                                                <p class="card-text">{{ $t('display-name', 'Display Name') }}
                                                        : <span>{{ account?.account_holder_name }}</span>
                                                    <button class="btn txt_copy_cl" @click="copyPaymentData($t('display-name', 'Display Name'), account?.account_holder_name,index)">
                                                        <i class="fa-solid fa-copy"></i>
                                                    </button>
                                                    <div class="copt_text_hover" v-if="copiedText">
                                                        {{ $t('copied', ' Copied') }}!
                                                    </div>
                                                </p>
                                                <p class="card-text" v-if="account?.crypto_wallet_id">
                                                    Deposit Amount
                                                        : <span>
                                                    {{ (depositAmount/account?.multiplier_value)?.toFixed(2) }} {{ account?.method_name}}
                                                    <span>( at x{{ Number(account?.multiplier_value) }} )</span>
                                                    </span>
                                                    <button class="btn txt_copy_cl" @click="copyPaymentData('Deposit Amount', (depositAmount/account?.multiplier_value),index)">
                                                        <i class="fa-solid fa-copy"></i>
                                                    </button>
                                                    <div class="copt_text_hover" v-if="copiedText">
                                                        {{ $t('copied', ' Copied') }}!
                                                    </div>
                                                </p>
                                                <div class="qrCode-pic" v-if="account.qr_code">
                                                    <div class="click-qr-preview-img" v-if="account.qr_code">
                                                        <button class="click-qr-icons" data-bs-toggle="modal" data-bs-target="#qrPreviewModal" 
                                                            @click="currentImgLink = account.qr_code">
                                                            <img loading="lazy" src="@/assets/images/qr-full-screen.svg" alt="qr-full-screen">
                                                        </button>
                                                        <button class="click-qr-icons" data-bs-toggle="modal" data-bs-target="#qrShareModal" 
                                                            @click="currentImgLink = account.qr_code">
                                                            <img loading="lazy" src="@/assets/images/qr-share.svg" alt="qr-share">
                                                        </button>
                                                        <button class="click-qr-icons" 
                                                            @click="downloadQrImg(account.qr_code, account?.account_holder_name)">
                                                            <img loading="lazy" src="@/assets/images/qr-downloads.svg" alt="qr-downloads">
                                                        </button>
                                                    </div>
                                                    <figure v-if="account.qr_code">
                                                        <img loading="lazy" :src="account.qr_code" alt="QR-Code">
                                                    </figure>
                                                </div>
                                            </div>
                                        </div>
                                        <div class="utr_proof_cl">
                                            <div class="form-group utr_file_input_grp" v-if="!previewImage">
                                                <label for="proofOfDeposit220225">{{ $t('upload-your-payment-proof', 'Upload Your Payment Proof') }} 
                                                    <small style="color: red;">[{{ $t('required', 'Required') }}]</small></label>
                                                <input type="file" class="form-control" @change="fileUpdateFunc" accept="image/png, image/jpg, image/jpeg, image/webp" />
                                            </div>
                                        </div>
                                        <div class="form-group" v-if="previewImage">
                                            <label>{{ $t('payment-slip', 'Payment Slip') }}</label>
                                            <div class="fileList deposit-previewImage">
                                                <img loading="lazy" class="fileList-img" :src="previewImage" alt="file-list"/>
                                                <button class="add-utr-again" @click="removeImage()">
                                                    &#10006;
                                                </button>
                                                <div class="timer loader_timer" v-if="utrLoader">
                                                    <div class="loader_deposit">
                                                    </div>
                                                    <text id="myTimer" text-anchor="middle" x="100" y="110" style="font-size: 40px; fill:#343434;">
                                                        {{ timerValue }}
                                                    </text>
                                                </div>
                                            </div>
                                            <div class="paymentProofFileUploadStatus" v-if="paymentProofFileUploadStatus">{{ paymentProofFileUploadStatus }}</div>      

                                        </div>
                                        <div v-if="init.transaction_image_url && !uploadedImage" class="error_cl" for="transactionId">{{ $t('please-upload-payment-proof', 'Please Upload Payment Proof') }}.</div>

                                        <div class="form-group amount_deposit_input amount_fillerd_inpt_box">
                                            <label for="transactionId">{{ $t('unique-transaction-reference', 'Unique Transaction Reference') }}
                                                <small style="color: red;" v-if="accountDetails?.method != 'wallet'">*</small>
                                            </label>
                                            <input type="tel" :maxlength="accountDetails?.method != 'wallet' ? 15 : 128" class="form-control utr_input_cl" v-model="manual_utr" @input="validateUTR(), manualEnterUtr = 1" :placeholder="$t('enter-utr-number', 'Enter UTR number')" />
                                            <div v-if="accountDetails?.method != 'wallet' && init.utr && !manual_utr?.length" class="error_cl">Please Enter UTR Number.</div>
                                            <div v-else-if="accountDetails?.method != 'wallet' && init.utr && manual_utr?.length < 10" class="error_cl">{{$t('utr-limit-msg','UTR number must be 10 to 15 digit')}}</div>
                                        </div>

                                        <div class="form-group amount_deposit_input amount_fillerd_inpt_box">
                                            <label for="exampleFormControlInput1">{{ $t('amount', 'Amount') }} <small style="color: red;">*</small></label>
                                            <input type="number" class="form-control" v-model="depositAmount" readonly />
                                        </div>

                                        <input type="hidden" id="accountId" value="220225" />
                                        <div class="custom-control custom_checkbox_cl">
                                            <input type="checkbox"  class="form-check-input custom-control-input" v-model="termsAgreed" />
                                            <label class="custom-control-label" for="termsCheck220225">{{ $t('i-have-read-and-agree-with', 'I have read and agree with') }}
                                                <a href="#termsAndCondition" data-bs-toggle="modal" class="terms_condition_cl">
                                                    {{ $t('the-terms-of-payment-and-withdrawal-policy', 'The terms of payment and withdrawal policy') }}.
                                                </a>
                                            </label>
                                        </div>
                                        <div class="submit_form_cl_div" ref="sbtBtn">
                                            <button type="button" class="withdrawBtn submit_form_cl" @click="walletDepositSubmitBtn()" :class="{ 'btn-loading': loading }">
                                                {{ $t('submit', 'Submit') }} <span><b></b><b></b><b></b></span>
                                            </button>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="no_deposit_parent text-center" v-else>
                        No Deposit Options Available. Contact Admin!!
                    </div>
                    <div class="description-card-body">
                        <div class="row">
                            <div class="col-12">
                                <WalletInstructions instructionType="deposit" />
                            </div>
                        </div>
                    </div>
                    <div class="deposit-main-body mt-2">
                        <div class="row">
                            <div class="col-12 col-sm-12 col-md-12 col-lg-12">
                                <div class="depo-rgt-container deposit_amount_table_cl">
                                    <WalletHistory ref="wallet_history"></WalletHistory>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <!-- term conditation modal pop up-->
    <div class="modal fade" id="termsAndCondition" tabindex="-1" role="dialog" aria-labelledby="exampleModalLabel">
        <div class="modal-dialog" role="document">
            <div class="modal-content">
                <div class="modal-header headerTheme">
                    <h5 class="modal-title">
                        {{ $t('the-terms-of-payment-and-withdrawal-policy', 'The terms of payment and withdrawal policy') }}
                    </h5>
                    <button type="button"  class="btn-close" data-bs-dismiss="modal" aria-label="Close" data-original-title="" title="">
                        <i class="fa-solid fa-xmark"></i>
                    </button>
                </div>
                <div class="modal-body">
                    <div class="term_condiation_body_wrapper p-0">
                        <p>
                        {{ $t('limits-the-maximum-deposit-limit-on-your-account', 'Limits The maximum deposit limit on your account will vary depending on how long you have been a customer with us and whether you have successfully passed our security checks.') }}
                        <span v-if="$siteSettings?.data?.social_link?.email">
                            {{ $t('please-contact-support', 'Please contact') }} 
                            <a :href="'mailto:' + $siteSettings?.data?.social_link?.email" class="text-primary " style="text-decoration: underline;">
                                    {{ $siteSettings?.data?.social_link?.email }}
                                </a>
                            {{ $t('for-further-information', 'for further information') }}.
                        </span>
                        </p>

                        <p>
                        {{ $t('security-please-note-you-may-be-asked-to-supply', 'Security Please note you may be asked to supply proof of identity and address before making a withdrawal from your account. Credit and Debit card payments undergo a 3D Secure process. To find out more, please click here.') }}
                        </p>

                        <p>
                        {{ $t('withdrawals-withdrawals-will-be-directed-to-the-same-source', 'Withdrawals will be directed to the same source. If your query is not covered by the information contained here, please email') }}
                        <span v-if="$siteSettings?.data?.social_link?.email">
                            <a :href="'mailto:' + $siteSettings?.data?.social_link?.email" class="text-primary" style="text-decoration: underline;">
                                    {{ $siteSettings?.data?.social_link?.email }}
                                </a>
                        </span>
                        {{ $t('where-staff-will-be-on-hand', 'where staff will be on hand to answer your query.') }}
                        </p>
                    </div>
                </div>
            </div>
        </div>
    </div>
     <!--qrPreview Modal -->
     <div class="modal fade" id="qrPreviewModal" tabindex="-1" aria-labelledby="qrPreviewLabel" aria-hidden="true">
        <div class="modal-dialog modal-dialog-centered">
            <div class="modal-content">
                <div class="modal-body">
                    <div class="qrPreview-image">
                        <img loading="lazy" :src="currentImgLink" alt="asg_rouletted1-thumb">
                    </div>
                    <div class="searchbar-main deposit-page-close">
                        <button type="button" class="closebtn-searchh deposit-page-close-btn" data-bs-dismiss="modal">Close</button>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <div class="modal fade" id="qrShareModal" tabindex="-1" aria-labelledby="qrPreviewLabel" aria-hidden="true">
        <div class="modal-dialog modal-dialog-centered">
            <div class="modal-content">
                <div class="modal-body">
                    <ul class="qrShare-list">
                        <li>
                            <a :href="`https://wa.me/?text=${currentImgLink}`" target="_blank">
                                <img loading="lazy" src="@/assets/images/whatsapp-share.svg" alt="whatsapp-share.svg">
                            </a>
                        </li>
                        <li>
                            <a :href="`https://www.facebook.com/sharer/sharer.php?u=${currentImgLink}`" target="_blank">
                                <img loading="lazy" src="@/assets/images/facebook-share.svg" alt="facebook-share.svg">
                            </a>
                        </li>
                        <li>
                            <a :href="`https://t.me/share/url?url=${currentImgLink}`" target="_blank">
                                <img loading="lazy" src="@/assets/images/telegram-share.svg" alt="telegram-share.svg">
                            </a>
                        </li>
                        <li>
                            <a href="https://www.instagram.com/" @click="copyImgUrl" target="_blank">
                                <img loading="lazy" src="@/assets/images/instagram-share.svg" alt="facebook-share.svg">
                            </a>
                        </li>
                    </ul>
                    <div class="searchbar-main deposit-page-close">
                        <button type="button" class="closebtn-searchh deposit-page-close-btn" data-bs-dismiss="modal">{{$t('close','Close')}}</button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script setup>

import { useStore } from 'vuex'
import { defineAsyncComponent, computed, ref, inject, reactive, onMounted,getCurrentInstance } from 'vue';
import { getParentPaymentsMethods, 
    onUploadImage, 
    submitDepositAmount, 
    getPaymentGatewayUrl,
    createSharedComputedForDepositPayment
} from '../services/depositPayment';
const WalletInstructions = defineAsyncComponent(() => import('../components/WalletInstructions.vue'));
const WalletHistory = defineAsyncComponent(() => import('../components/WalletHistory.vue'));
const { $t, $errorToast,$siteSettings,$successToast } = getCurrentInstance().proxy;
const store = useStore();
const walletConfig = inject('walletConfig')
        const paymentMethods = ref([])
        const parentPaymentsList = ref(null)
        const paymentDetailsList = ref(null)
        const accountDetails = ref(null)
        let paymentBonusRef = ref(null)
        const paymentProofFileUploadStatus = ref('');
        const awsS3Path = ref('')
        const activeTab = ref('')
        const bankS3url = ref('')
        const awsS3QrCode = ref('')

        const showFileError = ref(false)
        const showUtrError = ref(false)

        const selectedPaymentMethod = ref([])

        const uploadedImage = ref(null)
        const manual_utr = ref(0)
        const userJourneyVideo = ref(null)
        const file = ref(undefined)
        const loading = ref(false)
        const sbtBtn = ref(null)

        const walletData = ref(null)
        const selectPaymentAccount = ref(null)
        const previewImage = ref(null)
        const copiedText = ref(null)
        const walletLoading = ref(false)
        const currentImgLink = ref(null)

        // Timer related
        const t = ref(6)
        const interval = ref(30)
        const angle = ref(0)
        const angle_increment = ref(360 / 9)
        const intervalCounter = ref(0)
        const timerValue = ref(9)
        const timer = ref(null)

        const utrLoader = ref(false)
        const utrerror = ref(false)

        const init = reactive({
            utr: false,
            transaction_image_url: false
        })

        const termsAgreed = ref(false)
        const utrLimitError = ref(false)

        const currentAccount = ref(0)

        const utrMsg = reactive({
            langKey: 'enter-utr',
            msg: "Kindly enter UTR Number manually for fast deposit."
        })

        const isPaymentGateway = ref(null)
        const manualEnterUtr = ref(0)
        const depositAmount = computed(() => store.getters.depositAmount);
        const bonusData = computed(() => store.getters.bonusData);
        const methodIcons = computed(() => {
        const iconObj = {}
        walletConfig.value?.payment_method?.forEach(element => {
            iconObj[element.method_name] = element.icon
        })

        walletConfig.value?.bank_list?.forEach(element => {
            iconObj[element.bank_name] = element.icon
        })

        return iconObj
    });

onMounted(() => {
    getParentPaymentMethods();
});

const changeAccount = (account, index) => {
    currentAccount.value = index
    accountDetails.value = account
    toggleInit(false)
    clearPaymentSlip()
}
const startTimer = () => {
    utrLoader.value = true;
    angle.value = 0;
    intervalCounter.value = 0;
    timerValue.value = t.value;
    if (timer.value) {
        clearInterval(timer.value);
    }
         timer.value = setInterval(() => {
        intervalCounter.value++;
        angle.value = (intervalCounter.value / (t.value * (1000 / interval.value))) * 360;
        timerValue.value = t.value - Math.floor((angle.value / 360) * t.value);
        if (timerValue.value <= 0) {
            resetTimer();
            utrLoader.value = false;
        }
    }, interval.value);
};

const goToPaymentGateway = async () => {
    try {
        const response = await getPaymentGatewayUrl(
            depositAmount.value,
            paymentDetailsList.value[0].master_account_id
        );

        console.log(response);

    } catch (error) {
        $errorToast(error);
    }
};

const clearPaymentSlip = () => {
    previewImage.value = null;
    manual_utr.value = '';
    file.value = undefined;
    utrLimitError.value = '';
    utrerror.value = '';
    uploadedImage.value = null;
};


const copyPaymentData = (category, accountData) => {
    if (!accountData) {
        $errorToast($t('no-data-available-to-copy', 'No Data Available To Copy.'));
        return;
    }

    if (navigator.clipboard) {
        navigator.clipboard.writeText(accountData)
            .then(() => {
                $successToast(category + ' Copied Successfully');
            })
            .catch(() => {
                console.error("Failed to copy text");
            });
    } else {
        const input = document.createElement('textarea');
        input.value = accountData;
        document.body.appendChild(input);
        input.select();
        document.execCommand('copy');
        document.body.removeChild(input);

        copiedText.value = accountData;
        $successToast(category + ' Copied Successfully');
    }

    document.querySelectorAll('.copt_btn_toolTips .copty_cmn_btn i').forEach(el => {
        el.style.color = '';
    });

    setTimeout(() => {
        copiedText.value = null;
        document.querySelectorAll('.copty_cmn_btn i').forEach(el => {
            el.style.color = '#0cddff';
        });
    }, 1000);
};

const getParentPaymentMethods = async (reconnectTry = 0) => {
    try {
        const response = await getParentPaymentsMethods(
            reconnectTry,
            depositAmount.value
        );

        if (response?.data) {

            parentPaymentsList.value = response.data;

            const nonSocialStartIndex = response?.nonSocialStartIndex;

            activeTab.value = Object.keys(parentPaymentsList.value)[nonSocialStartIndex];

            choosePaymentMethod(
                parentPaymentsList.value[activeTab.value],
                activeTab.value
            );
             const { paymentBonus } = createSharedComputedForDepositPayment({bonusData: bonusData.value})
             paymentBonusRef = computed(paymentBonus);
        }

    } catch (error) {
        $errorToast(error);
    }
};

const choosePaymentMethod = (payment, index) => {
    clearPaymentSlip();
    toggleInit(false);
    activeTab.value = index
    paymentDetailsList.value = payment

    if (payment?.[0]?.method === 'social') {

        const socialNumber = payment?.[0]?.social_payment_number;
        const socialLink = payment?.[0]?.social_payment_link;

        if (socialNumber?.length && socialLink?.length) {
            const choice = Math.random() < 0.5 ? 'number' : 'link';

            if (choice === 'number') {
                const methodName = payment?.[0]?.method_name?.toLowerCase() || '';
                
                if (methodName.includes('whatsapp')) {
                    window.open(`https://wa.me/?text=${socialNumber}`, 'blank');
                } 
                else if (methodName.includes('telegram')) {
                    window.open(`https://t.me/${socialNumber}`, 'blank');
                }

            } else {
                window.open(socialLink, 'blank');
            }

            return;
        }

        if (socialNumber?.length) {
            const methodName = payment?.[0]?.method_name?.toLowerCase() || '';

            if (methodName.includes('whatsapp')) {
                window.open(`https://wa.me/?text=${socialNumber}`, 'blank');
            } 
            else if (methodName.includes('telegram')) {
                window.open(`https://t.me/${socialNumber}`, 'blank');
            }
            return;
        }

        if (socialLink?.length) {
            window.open(socialLink, 'blank');
            return;
        }

        $errorToast($t('no-social-payment-number', 'No social payment number available'));
        return;
    }

    if (payment?.[0]?.method === 'payment_gateway') {
        isPaymentGateway.value = true;
        paymentDetailsList.value = payment;
        return;
    }
    currentAccount.value = 0;
    accountDetails.value = paymentDetailsList.value?.[0];
    isPaymentGateway.value = false;
};

const toggleInit = (bool) => {
    init.utr = bool;
    init.transaction_image_url = bool;
};

const removeImage = () => {
    uploadedImage.value = null;
    previewImage.value = null;
    manual_utr.value = '';
};

const walletDepositSubmitBtn = async () => {
    try {
        termsAgreed.value = true;
        toggleInit(true);

        if (accountDetails.value?.method !== 'wallet' && manual_utr.value?.length < 11) {
            return;
        }

        const response = await submitDepositAmount({
            accountDetails: accountDetails.value,
            uploadedImage: uploadedImage.value,
            depositAmount: depositAmount.value,
            manual_utr: manual_utr.value,
            removeImage: removeImage,     // pass function
            has_edited_utr: manualEnterUtr.value
        });

    } catch (error) {
        console.log(error);
        $errorToast(error);
    }
};
const validateUTR = () => {
    manual_utr.value = manual_utr.value
        ?.replace(/[^0-9]/g, '')
        .replace(/[+-]/g, '');

    if (!manual_utr.value) {
        utrerror.value = true;
        utrLimitError.value = false;
    }
    else if (manual_utr.value.length < 10 || manual_utr.value.length > 15) {
        utrLimitError.value = true;
        utrerror.value = false;
    }
    else {
        utrLimitError.value = false;
        utrerror.value = false;
    }
};
const resetTimer = () => {
    clearInterval(timer.value);
    utrLoader.value = false;
    angle.value = 0;
    intervalCounter.value = 0;
    timerValue.value = t.value;
};

const fileUpdateFunc = async (event) => {
    try {
        paymentProofFileUploadStatus.value = 'Fetching payment proof file';
        const file = event.target.files[0];
        paymentProofFileUploadStatus.value = 'Payment Proof File found Ready to Process';
        previewImage.value = URL.createObjectURL(file);

        const response = await onUploadImage({
            event,
            depositAmount: depositAmount.value,
            startTimer: startTimer,
            resetTimer: resetTimer,
            sbtBtn: sbtBtn.value,
            paymentProofFileUploadStatus       
         });
        if (response) {
             if(!response?.manual_utr){
                    paymentProofFileUploadStatus.value = 'UTR Number Not Found from above payment proof try with different one';
            }else{
                paymentProofFileUploadStatus.value = 'UTR Number Has been successfully extracted !!!';
            }   
            manual_utr.value = response?.manual_utr;
            utrMsg.value = response?.utrMsg;  
            uploadedImage.value = response?.uploadedImage;
            previewImage.value = response?.previewImage;
            utrLoader.value = false;
        } else {
            paymentProofFileUploadStatus.value = 'Unable to Extract the UTR Number From Above Uploaded File , Please try with another file or try again after sometime';
            previewImage.value = null;
        }

    } catch (error) {
        paymentProofFileUploadStatus.value = 'Unable to Extract the UTR Number From Above Uploaded File , Please try with another file or try again after sometime';
        previewImage.value = null;
        $errorToast(error);
    }
     finally{
        setTimeout(() => {
            paymentProofFileUploadStatus.value = '';
        }, 2000);
    }
};

const copyImgUrl = () => {
    if (navigator.clipboard) {
        navigator.clipboard.writeText(currentImgLink.value)
            .then(() => {
                $successToast('Successfully copied.');
            })
            .catch(() => {
                console.error("Failed to copy text");
            });
    } else {
        const input = document.createElement('textarea');
        input.value = currentImgLink.value;
        document.body.appendChild(input);
        input.select();
        document.execCommand('copy');
        document.body.removeChild(input);

        $successToast('Successfully copied.');
    }
};

const downloadQrImg = (imageUrl, name) => {
    const link = document.createElement('a');
    link.href = imageUrl;
    link.download = name;
    link.target = '_blank';
    link.click();
};
</script>
<style>
.what-deposit {
    max-width: none !important;
}
</style>